var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnpropBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 241,
    viewBox: "0 0 174 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 89.8137H96.8174C82.5605 89.8137 68.8875 95.4144 58.8063 105.384C48.7252 115.353 43.0616 128.875 43.0616 142.973C43.0616 157.072 48.7252 170.594 58.8063 180.563C68.8875 190.532 82.5605 196.133 96.8174 196.133H98V241H96.8174C70.9344 240.404 46.3144 229.817 28.2218 211.503C10.1292 193.19 0 168.603 0 143C0 117.397 10.1292 92.8101 28.2218 74.4965C46.3144 56.1829 70.9344 45.5962 96.8174 45H98V89.8137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 151.08H99.1826C113.44 151.08 127.113 145.479 137.194 135.51C147.275 125.54 152.938 112.019 152.938 97.9203C152.938 83.8214 147.275 70.3 137.194 60.3306C127.113 50.3613 113.44 44.7605 99.1826 44.7605H98V0H99.1826C125.066 0.596184 149.686 11.1829 167.778 29.4965C185.871 47.8101 196 72.397 196 98C196 123.603 185.871 148.19 167.778 166.503C149.686 184.817 125.066 195.404 99.1826 196H98V151.08Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnpropBackground);
export default __webpack_public_path__ + "static/media/ownprop-background.2cf32e9048fce1547dad17dece8f8073.svg";
export { ForwardRef as ReactComponent };